/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { Ping200, PingReq } from '.././_model';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const ping = (
  pingReq: BodyType<PingReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<Ping200>(
    {
      url: `/ping`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pingReq,
      signal,
    },
    options,
  );
};

export const getPingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ping>>,
    TError,
    { data: BodyType<PingReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ping>>,
  TError,
  { data: BodyType<PingReq> },
  TContext
> => {
  const mutationKey = ['ping'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ping>>,
    { data: BodyType<PingReq> }
  > = props => {
    const { data } = props ?? {};

    return ping(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PingMutationResult = NonNullable<Awaited<ReturnType<typeof ping>>>;
export type PingMutationBody = BodyType<PingReq>;
export type PingMutationError = ErrorType<unknown>;

export const usePing = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ping>>,
      TError,
      { data: BodyType<PingReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ping>>,
  TError,
  { data: BodyType<PingReq> },
  TContext
> => {
  const mutationOptions = getPingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
